<template>
    <svg id="Grupo_15" data-name="Grupo 15" xmlns="http://www.w3.org/2000/svg" width="35.99" height="35.99" viewBox="0 0 35.99 35.99">
    <g id="Elipse_27" data-name="Elipse 27" transform="translate(0 16.227) rotate(-45)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="5">
        <circle cx="11.474" cy="11.474" r="11.474" stroke="none"/>
        <circle cx="11.474" cy="11.474" r="8.974" fill="none"/>
    </g>
    <path id="Caminho_7" data-name="Caminho 7" d="M0,0V11.474" transform="translate(24.341 24.341) rotate(-45)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="5"/>
    </svg>
</template>